const cookie = require('cookie-cutter');

/**
 * Get user data which cannot be passed via templates
 * (e.g. because of page cache)
 * Cookies are used for transmission of such data
 */
function getUserConfig() {
  return {
    isAuthenticated: Boolean(Number(cookie.get('isAuthenticated'))),
    isStaff: Boolean(Number(cookie.get('isStaff'))),
    isConfirmed: Boolean(Number(cookie.get('isConfirmed'))),
  };
}

module.exports = getUserConfig;
